import axios from 'axios';
import actionsInterceptor from '../interceptors/actions';
import dataInterceptor from '../interceptors/data';
import tokenInterceptor from '../interceptors/token';
import SPAVersionInterceptor from '../interceptors/checkSPAVersion';

const timeout = 10000;
const baseURL = process.env.REACT_APP_BASE_API;
const apiUrl = axios.create({
    baseURL,
    timeout,
    withCredentials: true
});

apiUrl.interceptors.request.use(tokenInterceptor.request);
apiUrl.interceptors.response.use(tokenInterceptor.response);
apiUrl.interceptors.response.use(actionsInterceptor.response);
apiUrl.interceptors.response.use(dataInterceptor.response, dataInterceptor.responseError);

const apiVoissa = axios.create({
    baseURL,
    timeout,
    withCredentials: true
});

apiVoissa.interceptors.request.use(tokenInterceptor.request);
apiVoissa.interceptors.response.use(tokenInterceptor.response);
apiVoissa.interceptors.request.use(SPAVersionInterceptor.request);
apiVoissa.interceptors.response.use(SPAVersionInterceptor.response);
apiVoissa.interceptors.response.use(actionsInterceptor.response);
apiVoissa.interceptors.response.use(dataInterceptor.response, dataInterceptor.responseQueryError);


const getForumsStatsFromApi = () => apiUrl.get(`/forums/stats`);
const tools = {
    getLiveBottom: (data = {}) => apiUrl.get(`/tools/live-bottom`, { params:data})
}

export {
    apiUrl,
    apiVoissa,
    getForumsStatsFromApi,
    tools,
};